import { CommercecloudStorefrontClient } from "./commercecloud-storefront";
import { MarcJacobsStorefrontClient } from "./marc-jacobs-storefront";

function isMarcJacobsStoreUrl(storeUrl: string): boolean {
  return storeUrl === "marcjacobs.com" || storeUrl.endsWith(".marcjacobs.com");
}

export function createCommercecloudStorefrontClient(
  options: ConstructorParameters<typeof CommercecloudStorefrontClient>[0],
): CommercecloudStorefrontClient {
  return isMarcJacobsStoreUrl(options.storeUrl)
    ? new MarcJacobsStorefrontClient(options)
    : new CommercecloudStorefrontClient(options);
}
